export function Percentage(value) {
  return Number(value).toLocaleString() + "%";
}
